import { CardsDataSourceBase } from "../../common/CardsDataSourceBase";
import { injectable } from "inversify";
import { injectToken } from "inversify-token";
import { YinzCamAPIResponse } from "yinzcam-api";
import { YinzCamAppServerToken } from "yinzcam-appserver";
import _ from "lodash";

@injectable()
export class YinzCamAppServerStandingsTypeFilter extends CardsDataSourceBase {
  public constructor(@injectToken(YinzCamAppServerToken) server) {
    super({ server })
  }

  protected processResponse(response: YinzCamAPIResponse, specData?: { [key: string]: any }): object | any[] {
    const data = response?.data as any;
    let options = this.getPhaseType(data);
    return { options };
  }
  
  getPhaseType(data: any): any {
    let filter = [].concat(data?.PhaseList?.Filters?.Filter).find(e => e?._attributes?.QueryParameter === 'phase');
    let phases = [].concat(filter?.FilterItems?.Items).filter(item => item?._attributes?.Id).map(item => {
        let attrs = item?._attributes;
        return {
          title: attrs?.Id,
          value: attrs?.ShowStandings
        };
      });
    return phases;
  }
}